import { HumanDepartment } from './../../../middleware/autorization'
export default [
  {
    path: 'list',
    name: 'list_employees',
    component: () => import('@/components/layouts/dashboard/ListEmployees'),
    beforeEnter: HumanDepartment,
    meta: {
      name: 'Lista de Funcionários',
      auth: true,
      user: 'Admin',
    },
  },
]
